<template>
  <div class="flex h-8 border-b border-blue-10">
    <TimetableCell v-for="n in emptyDaysStart" :key="'empty-start' + n" />
    <TimetableCell :day="day" v-for="(day, $i) in month.days" :key="$i" />
    <TimetableCell v-for="n in emptyDaysEnd" :key="'empty-end' + n" />
  </div>
</template>

<script>
import TimetableCell from './TimetableCell'

export default {
  name: 'TimetableRow',

  components: {
    TimetableCell
  },

  props: {
    month: Object
  },

  computed: {
    emptyDaysStart() {
      const dayOfWeek = this.month.days[0].dayOfWeek
      return dayOfWeek > 1 ? dayOfWeek - 1 : 0
    },

    emptyDaysEnd() {
      const totalDays = 5 * 7 + 2
      const currentLength = this.emptyDaysStart + this.month.days.length
      return totalDays - currentLength
    }
  }
}
</script>
